<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <button type="button" class="btn-close" (click)="cancel()"></button>
</div>

<form role="form" #createTimesheetform="ngForm" novalidate>
  <div class="modal-body">
   
    <nbc-alert></nbc-alert>
    <!--[ngClass]="{'has-error': createTimesheetform.name.$invalid && createTimesheetform.$submitted }"-->
    <div class="form-group" [ngClass]="{'has-error': createTimesheetform.status==='INVALID' && isFormSubmitted }">
      <label class="fw-bold">Name</label>
      <input type="text"
             appInputRestriction="restrictChars"
             class="form-control"
             id="name"
             name="name"
             autocomplete="off"
             [(ngModel)]="copyTimesheetSetting.name"
             placeholder="Required" maxlength="50" 
             (keyup.enter)="validateName(createTimesheetform)"
             required />    
    </div>
    <div class="form-group">
      <label class="fw-bold">Template</label>
      <div class="form-group">
        <!--<div nbc-dropdown [(ngModel)]="copyTimesheetSetting.templateId" nbc-source="templates" nbc-orderby="name" nbc-display="name" nbc-value="id" nbc-placeholder="Select Template"></div>-->
        <nbc-select [(model)]="copyTimesheetSetting.templateId"
                    name="templates"
                    [source]="templates"
                    value="id"
                    display="name"
                    placeHolderDisplay="Select Template"
                    placeHolderValue="-1">
        </nbc-select>
      </div>
    </div>
    <!--copyTimesheetSetting.templateId != 0--><!--Need to chcek-->
    <div *ngIf="copyTimesheetSetting.templateId != null"
         class="form-group">
      <label class="fw-bold">Fields to Copy</label>
      <ul>
        <li class="radio">
          <label><input type="radio"
                        name="copyContactField"
                        value="contactOnly"
                        [(ngModel)]="fieldToCopy"
                        (click)="copyField('contactOnly')" />Contacts Only</label>
        </li>
        <li class="radio">
          <label><input type="radio" name="copyContactField" value="contactTimecardOnly" [(ngModel)]="fieldToCopy" (click)="copyField('contactTimecardOnly')" [required]="copyTimesheetSetting.templateId != null && !copyTimesheetSetting.templateId" />Contacts and Timecards</label>
        </li>

      </ul>
    </div>
    <div class="form-group" *ngIf="copyTimesheetSetting.templateId != 0 && copyTimesheetSetting.contactTimecardOnly">
      <!--[checked]="copyTimesheetSetting.all"-->
      <label class="fw-bold"><input type="checkbox" id="select-all" [(ngModel)]="copyTimesheetSetting.all" [ngModelOptions]="{standalone: true}" name="selectAll" class="check-all-checkbox-el" [checked]="copyTimesheetSetting.all" (click)="OperationChecked()" />Timecard Fields</label>
      <ul>

        <li class="checkbox">
          <label><input type="checkbox" id="chkdayType" name="chkdayType" class="checkbox-el" [(ngModel)]="copyTimesheetSetting.dayType" [checked]="copyTimesheetSetting.dayType" (change)="optionToggled()" />DayType</label>
        </li>

        <li class="checkbox">
          <label><input type="checkbox"  id="chkeventType" name="chkeventType" class="checkbox-el" [(ngModel)]="copyTimesheetSetting.eventShow" [ngModelOptions]="{standalone: true}" [checked]="copyTimesheetSetting.eventShow" (change)="optionToggled()" />Event/Show</label>
        </li>
        <li class="checkbox">
          <label><input type="checkbox" name="chkSport" [(ngModel)]="copyTimesheetSetting.sport" [ngModelOptions]="{standalone: true}" [checked]="copyTimesheetSetting.sport" (change)="optionToggled()" />Sport</label>
        </li>
        <li class="checkbox">
          <label><input type="checkbox" name="chkNetwork" [(ngModel)]="copyTimesheetSetting.network" [ngModelOptions]="{standalone: true}" [checked]="copyTimesheetSetting.network" (change)="optionToggled()" />Network</label>
        </li>
        <li class="checkbox">
          <label><input type="checkbox" name="chkEmpType" [(ngModel)]="copyTimesheetSetting.employeeType" [ngModelOptions]="{standalone: true}" [checked]="copyTimesheetSetting.employeeType" (change)="optionToggled()" />Employee Type</label>
        </li>
        <li class="checkbox">
          <label><input type="checkbox" name="chkworkState" [(ngModel)]="copyTimesheetSetting.workState" [ngModelOptions]="{standalone: true}" [checked]="copyTimesheetSetting.workState" (change)="optionToggled()" />Work State</label>
        </li>
        <li class="checkbox">
          <label><input type="checkbox" name="chkrate" [(ngModel)]="copyTimesheetSetting.rate" [ngModelOptions]="{standalone: true}" [checked]="copyTimesheetSetting.rate" (change)="optionToggled()" />Rate (Day)</label>
        </li>
        <li class="checkbox">
          <label><input type="checkbox" name="chkhourWorked" [(ngModel)]="copyTimesheetSetting.hoursWorked" [ngModelOptions]="{standalone: true}" [checked]="copyTimesheetSetting.hoursWorked" (change)="optionToggled()" />Hours Worked</label>
        </li>
        <li class="checkbox">
          <label><input type="checkbox" name="chkcompanyCode" [(ngModel)]="copyTimesheetSetting.companyCode" [ngModelOptions]="{standalone: true}" [checked]="copyTimesheetSetting.companyCode" (change)="optionToggled()" />Company Code</label>
        </li>
        <li class="checkbox">
          <label><input type="checkbox" name="chkWBSECostcenter" [(ngModel)]="copyTimesheetSetting.wbseCostCenter" [ngModelOptions]="{standalone: true}" [checked]="copyTimesheetSetting.wbseCostCenter" (change)="optionToggled()" />WBSE/Cost Center</label>
        </li>
        <li class="checkbox">
          <label><input type="checkbox" name="chkglaccount" [(ngModel)]="copyTimesheetSetting.glAccount" [ngModelOptions]="{standalone: true}" [checked]="copyTimesheetSetting.glAccount" (change)="optionToggled()" />GL Account</label>
        </li>
      </ul>
    </div> 
  </div>
  <div class="modal-footer">
    <!--(click)="validateName(createTimesheetform)"-->
    <!--[disabled]="createTimesheetform.name.$invalid ||createTimesheetform.$submitted"--> 
    <button type="button" class="btn btn-primary" id="btnCreateTimesheet"
            [disabled]="createTimesheetform.status==='INVALID' || isFormSubmitted"
            (click)="validateName(createTimesheetform)">
      Create
    </button>
    <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
  </div>
</form>
